
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60.123 60.123"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.124 51.893H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 33.062H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 14.231H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6z"}}),_c('circle',{attrs:{"cx":"4.029","cy":"11.463","r":"4.029"}}),_c('circle',{attrs:{"cx":"4.029","cy":"30.062","r":"4.029"}}),_c('circle',{attrs:{"cx":"4.029","cy":"48.661","r":"4.029"}})])
          )
        }
      }
    